/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
export const AccountNumberFormatter = (cellContent, row, rowIndex) => {
  const { account_number } = row;
  return (
    <>
      {account_number ? account_number : "-"}
      <> </>
    </>
  );
};
